import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  isGalleryEditor as _isGalleryEditor,
  templateData,
} from "../../Template/NewTemplateSignals";

export const automationIds = () => {
  return templateData.value.properties?.Automations?.filter((automation) => {
    const nodes = automation.model.layers.find((layer) => layer.type === "diagram-nodes");
    const triggerNode = Object.values(nodes.models).find(
      (node) => node.extras.properties.Type === "Trigger"
    );
    return triggerNode?.extras?.properties?.TriggerType === "Manual";
  }).map((automation) => automation.name);
};

export const AutomationProperty = {
  propertyName: "Automation",
  propertyDisplay: "Automation to Run",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues, isGalleryEditor }) {
    _isGalleryEditor.value = isGalleryEditor;
    return (
      <DropDownList
        data={automationIds()}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName]}
      />
    );
  },
};
